import React from "react";
import { useModal } from "@/contexts/ModalContext";
import CTA from "@/components/atoms/CTA";
import Text from "@/components/atoms/Text";
import Group from "@/components/atoms/Group";
import { useMediaQuery } from "@mantine/hooks";
import { Modal } from "@mantine/core";
import Divider from "@/components/atoms/Divider";

export const GlobalModal: React.FC = () => {
  const { modalConfig, closeModal } = useModal();
  const { isOpen, title, content, primaryAction, secondaryAction, isCloseVisible } = modalConfig;
  const isMobile = useMediaQuery("(max-width: 50em)");

  return (
    <Modal
      opened={isOpen}
      fullScreen={isMobile}
      onClose={closeModal}
      title={title}
      zIndex={2000}
      withCloseButton={isCloseVisible}
      transitionProps={{ transition: "slide-down", duration: 100 }}
      data-testid="global-modal"
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
    >
      {typeof content === "string" ? <Text size={"sm"}>{content}</Text> : content}

      {(primaryAction || secondaryAction) && (
        <>
          <Divider />
          <Group justify={"flex-end"}>
            {secondaryAction && (
              <CTA
                id={secondaryAction.id || "modal-secondary-action"}
                intent={secondaryAction.intent}
                onClick={() => {
                  secondaryAction.onClick();
                  closeModal();
                }}
              >
                {secondaryAction.text}
              </CTA>
            )}

            {primaryAction && (
              <CTA
                id={primaryAction.id || "modal-primary-action"}
                intent={primaryAction.intent}
                onClick={() => {
                  primaryAction.onClick();
                  closeModal();
                }}
              >
                {primaryAction.text}
              </CTA>
            )}
          </Group>
        </>
      )}
    </Modal>
  );
};

export default GlobalModal;
